import React from "react";

const Mission = () => (
  <div className="min-h-screen bg-[#23283b] flex items-center justify-center px-4 py-16">
    <div className="max-w-2xl mx-auto bg-[#1b1e29] rounded-xl shadow p-8">
      <h1 className="text-3xl md:text-4xl font-bold mb-6 text-blue-400">Notre Mission</h1>
      <p className="text-lg text-gray-200 mb-4">
        Chez <span className="font-bold text-white">1PARC</span>, notre mission est de transformer l’expérience automobile en Afrique de l’Ouest en apportant transparence, efficacité et confiance à chaque étape du cycle de vie du véhicule.
      </p>
      <p className="text-lg text-gray-200 mb-4">
        Nous connectons propriétaires, ateliers, fournisseurs, compagnies d’assurance et services d’assistance sur une seule plateforme intelligente. Notre objectif : simplifier les démarches, réduire les coûts cachés, sécuriser les transactions et assurer un suivi complet pour tous les acteurs du secteur.
      </p>
      <p className="text-lg text-gray-200">
        Grâce à la digitalisation, à la traçabilité et à l’intégration de l’IA, nous voulons permettre à chacun de gérer, entretenir et protéger son véhicule avec sérénité, tout en soutenant la croissance et la professionnalisation de l’écosystème automobile local.
      </p>
    </div>
  </div>
);

export default Mission;
